import { QueueItemType } from 'common/api/endpoints/queue';

import type { InboxCannyPostItem, InboxDraftItem, QueueInboxItem } from './types';

export const isPostDraft = (item: QueueInboxItem): item is InboxDraftItem =>
  item.type === QueueItemType.draft;

export const isCannyPost = (item: QueueInboxItem): item is InboxCannyPostItem =>
  item.type === QueueItemType.post;
